import { DocumentTitle } from '@/components/layout/DocumentTitle';
import { DesignSystemShowcase } from '@/components/design-system/DesignSystemShowcase';
import { View } from 'react-native';

export default function DesignSystemScreen() {
  return (
    <View className="flex h-full min-h-0 flex-1 flex-col">
      <DocumentTitle title="Design system" />
      <DesignSystemShowcase />
    </View>
  );
}
